import { Goal } from '../typings/goals';

export const FETCH_GOALS_DATA = 'FETCH_GOALS_DATA';
export type FETCH_GOALS_DATA = typeof FETCH_GOALS_DATA;

export interface FetchGoalsData {
    type: FETCH_GOALS_DATA;
}

export function fetchGoalsData(): FetchGoalsData {
    return {
        type: FETCH_GOALS_DATA
    };
}

export const UPDATE_GOALS_DATA = 'UPDATE_GOALS_DATA';
export type UPDATE_GOALS_DATA = typeof UPDATE_GOALS_DATA;

export interface UpdateGoalsData {
    type: UPDATE_GOALS_DATA;
    goals: Record<string, Goal>;
}

export function updateGoalsData(goals: Record<string, Goal>): UpdateGoalsData {
    return {
        type: UPDATE_GOALS_DATA,
        goals
    };
}

export type GoalsDataAction = FetchGoalsData | UpdateGoalsData;
